import { Course, CourseType } from "@/models/courses.model";
import { defineStore } from "pinia";
import { instance } from "./index";

const store = defineStore({
  id: "course-student",
  state: () => ({
    courseType: JSON.parse(localStorage.getItem("course-type") as string),
    h5pId: null as string | null,
    data: new Course(),
  }),
  getters: {
    getData: (state) => state.data,
    getH5pId: (state) => {
      if (state.h5pId) return state.h5pId;
      const local = localStorage.getItem("h5pId");
      if (local && local !== "null" && local !== "undefined" && local !== "") {
        try {
          const parsed = JSON.parse(local);
          if (parsed && parsed !== "null" && parsed !== "undefined")
            return parsed;
        } catch (e) {
          return local;
        }
      }
      return null;
    },
    getCourseType: (state) => state.courseType,
  },
  actions: {
    setData(value: Course) {
      this.data = value;
    },
    setH5pId(value: string | null) {
      this.h5pId = value;
      localStorage.setItem("h5pId", this.h5pId!);
    },
    setCourseType(value: CourseType) {
      this.courseType = value;
    },
  },
});

export const useCourseStudentStore = store(instance);
